import React, { useEffect, useState } from "react";
import {
  Box,
  Input,
  Table,
  TableContainer,
  IconButton,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Button,
  Checkbox
} from "@chakra-ui/react";
import Pagination from "../../../../elements/Pagination";
import { ChevronRightIcon } from "@chakra-ui/icons";
import moment from "moment";
import Loader from "../../../../elements/loader";
import { bindActionCreators } from "redux";
import { ActionCreators } from "../../../../../redux/actions";
import { connect, useSelector } from "react-redux";
import NoData from "../../../../elements/NoData";
// import { Button } from "react-bootstrap";

const UpdatedRecovery_Data = (props) => {
  const adminState = useSelector((state) => state.adminState);
  const [currentPage, setCurrentPage] = useState(0);
  const [filterData, setFilterData] = useState([]);
  const [selectCheckRecovery,setSelectCheckRecovery] =useState(false)
  const Recovery_Data = adminState?.getRecovery_Data?.data?.data
  const PER_PAGE = 10;
  const offset = currentPage * PER_PAGE;
  const pageCount = Math.ceil(Recovery_Data?.length / PER_PAGE);
  useEffect(() => {
    if (props.tabSelected === "Recovery Data") {
      props?.actions?.getRequeryDetailsAction();
    }
   
  }, [props.tabSelected]);

  useEffect(() => {
    if (adminState?.getRecovery_Data?.data?.success === true) {
      setFilterData(Recovery_Data);
    }
  }, [adminState?.getRecovery_Data]);

  const handleSearch = (e) => {
    const {value} = e.target
       setCurrentPage(0)
       if (value !== '') {
        const result = Recovery_Data.filter((item) => {
          console.log("itemRRRRR",item)
          return (item?.loan_number?.toLowerCase().includes(value.toLowerCase()) ||  item?.first_name?.toLowerCase().includes(value.toLowerCase()) || item?.last_name?.toLowerCase().includes(value.toLowerCase())|| item?.middle_name?.toLowerCase().includes(value.toLowerCase())
          || item?.mobile?.toLowerCase().includes(value.toLowerCase()) || item?.cp_name?.toLowerCase().includes(value.toLowerCase()) || item?.loan_contract_number?.toLowerCase().includes(value.toLowerCase()) || item?.loan_amount?.toLowerCase().includes(value.toLowerCase())
          || item?.recovery_amount?.toLowerCase().includes(value.toLowerCase()) || String(item?.recovery_outstanding_amount || '').toLowerCase().includes(String(value || '').toLowerCase()) || String(item?.days_overdue || '').toLowerCase().includes(String(value || '').toLowerCase())
          || String(item?.total_outstanding_dues || '').toLowerCase().includes(String(value || '').toLowerCase()) ||  String(item?.total_outstanding_dues || '').toLowerCase().includes(String(value || '').toLowerCase())
        )
        })
        setFilterData(result)        
      } else {
        setFilterData(Recovery_Data)
      }
    };
  const handlePageClick = ({ selected: selectedPage }) => {
    setCurrentPage(selectedPage);
  };
  const handleChange =(value)=>{
    
    setSelectCheckRecovery((preState)=>{
      const newSet =new Set(preState)
      if(newSet.has(value)){
        newSet.delete(value)
      }
      else{
        newSet.push(value)
      }
      return newSet
    })
  }
  return (
    <>
      {adminState?.getRecovery_Data?.loading  && (
          <div>
            <Loader />
          </div>
        )}
      <Box mt={1}>
        <Box className="search_box">
          <Input
            type="text"
            size="md"
            name="search"
            placeholder="Search"
            onChange={handleSearch}
            className="input_box font-poppins"
          />
        </Box>
        <>
        {filterData?.length > 0 ? (
            <Box mt={2} className="custom_table_wrapper custom_table_wrapper2">
              <TableContainer>
                <Table variant="simple">
                  <Thead>
                    <Tr>
                      <Th>S.No.</Th>
                      <Th>Days Overdue</Th>
                      {/* <Th>Total Recoverable Amount</Th> */}
                      <Th>Recovery Percentage %</Th>
                      <Th>Total Outstanding Amount</Th>
                      <Th>Mobile</Th>
                      <Th>Name</Th>
                      <Th>Channel Partner Name</Th>
                      <Th>Loan No.</Th>
                      <Th>Reovery Amount</Th>
                      <Th>Reovery Outstanding Amount</Th>
                      <Th>Loan Contract</Th>
                      <Th>Loan Disbursed Date</Th>
                      <Th>Loan EMI Date</Th>
                      <Th>Loan EMI Amount</Th>
                      <Th>Loan Amount</Th>
                      <Th>Tenure(Days)</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {filterData
                      ?.slice(offset, offset + PER_PAGE)
                      ?.map((item, index) => {
                        const serialNumber = offset + index + 1;
                        return (
                          <Tr key={index}>
                            <Td>
                              <Text className="font-poppins table_text" style={{marginRight:"30px"}}>
                                {serialNumber}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.days_overdue ? item?.days_overdue : "NA"}
                              </Text>
                            </Td> 
                            <Td>
                                 {item?.recovery_percentage ? item?.recovery_percentage :"NA"}
                                    </Td>
                            <Td>
                              <Text className="font-poppins  gray_text">
                                {item?.total_outstanding_dues ? item?.total_outstanding_dues : "NA"}
                              </Text>
                              </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.mobile ? item?.mobile : "NA"}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.first_name} {item?.last_name} {item?.middle_name}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.cp_name ? item?.cp_name : "NA"}
                              </Text>
                            </Td>
                          
                              <Td>
                                <Text className="font-poppins table_text">
                                  {item?.loan_number ? item?.loan_number : "NA"}
                                </Text>
                              </Td>
                              <Td>
                                <Text className="font-poppins table_text">
                                  {item?.recovery_amount ? item?.recovery_amount : "NA"}
                                </Text>
                              </Td>
                              <Td>
                                <Text className="font-poppins table_text">
                                  {item?.recovery_outstanding_amount ? item?.recovery_outstanding_amount : "NA"}
                                </Text>
                              </Td>
                           
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.loan_contract_number
                                  ? item?.loan_contract_number
                                  : "Not Assigned"}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.disbursed_date
                                  ? moment(item?.disbursed_date).format(
                                    "DD-MMM-YYYY"
                                  )
                                  : "Not Available"}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.emi_date
                                  ? moment(item?.emi_date).format("DD-MMM-YYYY")
                                  : "Not Available"}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.emiAmount? item?.emiAmount: "Not Available"}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.loan_amount ? item?.loan_amount : "Not Available"}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.tenure ? item?.tenure : "Not Available"}
                              </Text>
                            </Td>
                          </Tr>
                        );
                      })}
                  </Tbody>
                
                </Table>
              </TableContainer>
              <Pagination
                pageCount={pageCount}
                handlePageClick={handlePageClick}
              />
            </Box>
        ) : (
          <NoData title="No Record Found" />
        )}
        </>
       
      </Box>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ActionCreators, dispatch),
});

export default connect(null, mapDispatchToProps)(UpdatedRecovery_Data);